module.exports = __webpack_public_path__ + "static/media/19ESCAP23.b52b672a.jpg";